import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_authenticated/dashboard/compliance")({
	validateSearch: z.object({
		q: z.string().optional(),
	}),
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/settings/compliance", search });
	},
});
